import api from './api';

export function saveComment(comment) {
  return api.post('/comentarios', comment);
}

export function listComments(idEtapa) {
  return api.get(`/etapas/${idEtapa}/comentarios`);
}
